import React from 'react'
import Registry from 'live/services/registry'
import AutoAnalysisAnnotation from 'plugin-assets/shared/auto-analysis/auto-analysis-annotation'
import temporalAnalysisApi from '../api'

const AutoAnalysisAnnotationTimeline = props => (
    <AutoAnalysisAnnotation {...props} api={temporalAnalysisApi} mode="temporal" variant="timeline" />
)

AutoAnalysisAnnotationTimeline.displayName = 'AutoAnalysisAnnotationTimeline'

const AutoAnalysisAnnotationMessenger = props => (
    <AutoAnalysisAnnotation {...props} api={temporalAnalysisApi} mode="temporal" variant="messenger" />
)

AutoAnalysisAnnotationMessenger.displayName = 'AutoAnalysisAnnotationMessenger'

export default function autoAnalysisEventRenderer(variant) {
    return function(event) {
        if (isTemporalAutoAnalysisEvent(event)) {
            return {
                priority: 99,
                component: variant === 'timeline' ? AutoAnalysisAnnotationTimeline : AutoAnalysisAnnotationMessenger
            }
        }
    }
}

export const AnnotationActionRegistry = new Registry()

export function isTemporalAutoAnalysisEvent(event) {
    return (
        event.__type === '__annotations' &&
        event.__src !== undefined &&
        event.__src === 'auto-analysis' &&
        (!event.extra.type || event.extra.type === 'time')
    )
}
